import { Card, Space, Typography } from "antd"
import VSpace from "../../common/VSpace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CheckboxButton from "../../common/CheckboxButton"
import { faBank, faCreditCard } from "@fortawesome/pro-solid-svg-icons"
import { InvoiceSendOptions } from "../../../domain/invoicing/invoicingApi"

type Props = {
  options: InvoiceSendOptions
  onUpdate: (updated: InvoiceSendOptions) => void
  documentLabel?: string
}

const PaymentMethodsCard = ({ options, onUpdate, documentLabel = 'Invoice' }: Props) => {
  return <Card
    title={<div style={{ margin: "16px 0" }}>
    Payment Methods
    <br/>
    <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
      Select the payment methods your customer can use to pay this {documentLabel.toLowerCase()}.
    </Typography.Text>
  </div>}
  >
    <VSpace>
      <CheckboxButton
        checked={options.enableCreditCardPayments}
        onClick={() => onUpdate({ ...options, enableCreditCardPayments: !options.enableCreditCardPayments })}
      >
        <Space style={{fontSize: '14px'}}>
          <FontAwesomeIcon icon={faCreditCard} />
          Card
        </Space>
      </CheckboxButton>
      <CheckboxButton
        checked={options.enableAchPayments}
        onClick={() => onUpdate({ ...options, enableAchPayments: !options.enableAchPayments })}
      >
        <Space style={{fontSize: '16px'}}>
          <FontAwesomeIcon icon={faBank} />
          Bank Transfer
        </Space>
      </CheckboxButton>
    </VSpace>
  </Card>
}

export default PaymentMethodsCard
